/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Undo_LastInputs */

const en_us2_workout_undo_last = /** @type {(inputs: Workout_Undo_LastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Undo the last set`)
};

const pt_br2_workout_undo_last = /** @type {(inputs: Workout_Undo_LastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desfazer a última série`)
};

const es_419_workout_undo_last = /** @type {(inputs: Workout_Undo_LastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deshacer la última serie`)
};

const pt_pt2_workout_undo_last = /** @type {(inputs: Workout_Undo_LastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anular a última série`)
};

const fr_fr2_workout_undo_last = /** @type {(inputs: Workout_Undo_LastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annuler la dernière série`)
};

const de_de2_workout_undo_last = /** @type {(inputs: Workout_Undo_LastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Letzten Satz rückgängig machen`)
};

const it_it2_workout_undo_last = /** @type {(inputs: Workout_Undo_LastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annulla l'ultima serie`)
};

/**
* | output |
* | --- |
* | "Undo the last set" |
*
* @param {Workout_Undo_LastInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_undo_last = /** @type {((inputs?: Workout_Undo_LastInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Undo_LastInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_undo_last(inputs)
	if (locale === "es-419") return es_419_workout_undo_last(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_undo_last(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_undo_last(inputs)
	if (locale === "de-DE") return de_de2_workout_undo_last(inputs)
	if (locale === "it-IT") return it_it2_workout_undo_last(inputs)
	return en_us2_workout_undo_last(inputs)
});
export { workout_undo_last as "workout.undo_last" }